import { Text } from '@loadsmart/loadsmart-ui'

import { isEqual } from 'core/utils/date'

import { formatZonedDate } from 'legacy/utils/date/formatZonedDate'

import { type LoadIntermodal } from '../../domain/LoadIntermodal'
import { type LoadStop } from '../../domain/LoadStop'
import { getStopInfo } from '../../presenters/stopInfoPresenter'
import { Location } from './LoadSummary.styles'

type LoadSummaryStopProps = {
  intermodal?: LoadIntermodal
  stop: LoadStop
}

export function LoadSummaryStop({ intermodal, stop }: LoadSummaryStopProps) {
  const { timezone, windowStart, windowEnd } = stop
  const { label, location, appointment } = getStopInfo(stop, intermodal)
  const isAppointmentWindow = !isEqual(windowStart, windowEnd)
  const date = formatZonedDate(windowStart, timezone, 'EEE, MMM d')
  const start = formatZonedDate(windowStart, timezone, 'HH:mm')
  const end = isAppointmentWindow ? ` - ${formatZonedDate(windowEnd, timezone, 'HH:mm')}` : ''
  const time = ` ${start}${end}`

  return (
    <div>
      <Text as="div" variant="caption-bold" color="color-neutral-dark">
        {label}
      </Text>
      <Location>{location}</Location>
      <Text as="div" variant="body">
        ZIP {stop.zipcode}
      </Text>
      <Text as="div" variant="body">
        {appointment && appointment}
        {!appointment && `${date}${time}`}
      </Text>
    </div>
  )
}
